import { render, staticRenderFns } from "./InternalServers.vue?vue&type=template&id=21c37226&scoped=true&"
import script from "./InternalServers.vue?vue&type=script&lang=ts&"
export * from "./InternalServers.vue?vue&type=script&lang=ts&"
import style0 from "./InternalServers.vue?vue&type=style&index=0&id=21c37226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c37226",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VFlex,VIcon,VSelect})
